












































































































  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import moment from "moment";
  import VesselFeatureChart from "./VesselFeatureChart.vue";

@Component({
  components: {
    VesselFeatureChart,
  },
})
  export default class AllTimelinesModal extends Vue {
  @Prop({ required: true, type: Boolean }) value!: boolean;
  @Prop({ required: true, type: Number }) vesselId!: number;
  @Prop({ required: true, type: String }) vesselName!: string;
  @Prop({ type: Array, default: () => [] }) featureNames!: string[];
  @Prop({ required: true, type: String }) fromDate!: string;
  @Prop({ required: true, type: String }) toDate!: string;

  private hasStartedLoading = false;
  private renderedCharts = new Set<number>();
  private loadingIndex = 0; // Track which chart is currently being loaded

  // Make VesselFeatureChart available to template
  VesselFeatureChart = VesselFeatureChart;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit("input", value);
  }


  shouldRenderChart(index: number): boolean {
    return this.renderedCharts.has(index);
  }

  @Watch("dialog")
  onDialogChange(newVal: boolean) {
    if (!newVal) {
      // Reset state when closing
      this.hasStartedLoading = false;
      this.loadingIndex = 0;
      this.renderedCharts.clear();
    }
  }

  async startLoadingAllTimelines() {
    this.hasStartedLoading = true;
    this.loadingIndex = 0;

    // Start progressive loading
    this.loadNextChart();
  }

  loadNextChart() {
    if (this.loadingIndex >= this.featureNames.length) {
      return; // All charts processed
    }

    // Render the current chart component
    this.renderedCharts.add(this.loadingIndex);

    // The component will start loading automatically via :loadImmediately="loadingIndex === index"
    // Move to next chart after delay
    setTimeout(() => {
      this.loadingIndex++;
      this.loadNextChart();
    }, 300);
  }

  onChartLoaded(featureName: string) {
    // Chart loaded successfully
  }

  onChartError(featureName: string) {
    // Chart failed to load
  }

  formatDateRange(from: string, to: string): string {
    return `${moment(from).format("MMM DD, YYYY")} - ${moment(to).format("MMM DD, YYYY")}`;
  }

  close() {
    this.dialog = false;
  }
  }
